var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dynamic',{attrs:{"sign":"all"}}),_c('div',{staticClass:"paiZhao",on:{"click":_vm.releaseContents}},[_c('img',{attrs:{"src":require("../../assets/images/write.png"),"alt":""}}),_c('span',[_vm._v("发表动态")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }